/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIEmailAddressRequest
 */
export interface APIEmailAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof APIEmailAddressRequest
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIEmailAddressRequest
     */
    verified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIEmailAddressRequest
     */
    primary?: boolean;
}

/**
 * Check if a given object implements the APIEmailAddressRequest interface.
 */
export function instanceOfAPIEmailAddressRequest(value: object): value is APIEmailAddressRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function APIEmailAddressRequestFromJSON(json: any): APIEmailAddressRequest {
    return APIEmailAddressRequestFromJSONTyped(json, false);
}

export function APIEmailAddressRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIEmailAddressRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'verified': json['verified'] == null ? undefined : json['verified'],
        'primary': json['primary'] == null ? undefined : json['primary'],
    };
}

export function APIEmailAddressRequestToJSON(value?: APIEmailAddressRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'verified': value['verified'],
        'primary': value['primary'],
    };
}

